import React, { useEffect, useMemo, useState } from 'react';
import { ActionButton, MultiSelectList } from '@/shared/components/ui';
import { employeeRecords } from '@/shared/data';
import { useUIStore } from '@/stores/uiStore';
import { ASSIGN_KEY, loadAssignments, saveAssignments } from './AssignWorkScheduleModal';

export default function ViewWorkScheduleAssignmentsModal({ onClose, data }) {
  const schedule = data?.schedule;
  const { showSuccessToast } = useUIStore();
  const [assignments, setAssignments] = useState({});
  const [modeAdd, setModeAdd] = useState(false);
  const [selected, setSelected] = useState(new Set());

  useEffect(() => { setAssignments(loadAssignments()); }, []);

  const currentIds = assignments[schedule?.id] || [];
  const currentEmployees = currentIds.map(id => employeeRecords.find(e => e.id === id)).filter(Boolean);

  const unassigned = useMemo(() => employeeRecords.filter(e => !currentIds.includes(e.id)), [currentIds]);

  const toggle = (id) => setSelected(s => { const n = new Set(s); n.has(id) ? n.delete(id) : n.add(id); return n; });

  const remove = (id) => {
    const map = loadAssignments();
    map[schedule.id] = (map[schedule.id] || []).filter(eid => eid !== id);
    saveAssignments(map);
    setAssignments(map);
    showSuccessToast('Removed', 'Employee removed from schedule.');
  };

  const addSelected = () => {
    if (!selected.size) return;
    const map = loadAssignments();
    const existing = map[schedule.id] || [];
    map[schedule.id] = [...existing, ...Array.from(selected)];
    saveAssignments(map);
    setAssignments(map);
    setSelected(new Set());
    setModeAdd(false);
    showSuccessToast('Assignments updated', 'Employees added to schedule.');
  };

  return (
    <div className="space-y-4">
      <div>
        <h2 className="text-lg font-semibold">Assigned Employees</h2>
        <p className="text-sm text-neutral-500">Work schedule: <span className="font-medium">{schedule?.name}</span></p>
      </div>

      <div className="space-y-1">
        {currentEmployees.map(emp => (
          <div key={emp.id} className="flex items-center px-3 py-2 text-sm border rounded hover:bg-neutral-50">
            <span className="flex-1 truncate">{emp.fullName}</span>
            <button onClick={() => remove(emp.id)} className="text-xs text-red-600 hover:underline">Remove</button>
          </div>
        ))}
        {!currentEmployees.length && <div className="px-3 py-6 text-center text-sm text-neutral-500 border rounded">No employees assigned.</div>}
      </div>

      {!modeAdd && (
        <div className="flex justify-between">
          <ActionButton variant="secondary" onClick={onClose}>Close</ActionButton>
        </div>
      )}

      {/* {modeAdd && (
        <div className="space-y-3">
          <div className="flex items-center justify-between">
            <h3 className="font-medium text-sm">Add Employees</h3>
            <button onClick={() => { setModeAdd(false); setSelected(new Set()); }} className="text-xs text-neutral-500 hover:underline">Cancel Add</button>
          </div>
          <MultiSelectList
            items={unassigned}
            selected={selected}
            getId={(e) => e.id}
            renderLabel={(e) => e.fullName}
            allVisibleSelected={unassigned.length > 0 && unassigned.every(u => selected.has(u.id))}
            onToggle={toggle}
            onToggleAll={(e) => {
              if (unassigned.length && unassigned.every(u => selected.has(u.id))) {
                setSelected(new Set());
              } else {
                setSelected(new Set(unassigned.map(u => u.id)));
              }
            }}
            headerLabel="Employee Name"
            emptyMessage="All employees already assigned."
            height="15rem"
          />
          <div className="flex justify-end gap-3">
            <ActionButton variant="secondary" onClick={() => { setModeAdd(false); setSelected(new Set()); }}>Done</ActionButton>
            <ActionButton variant="primary" disabled={!selected.size} onClick={addSelected}>Add Selected ({selected.size})</ActionButton>
          </div>
        </div>
      )} */}
    </div>
  );
}